import React from 'react';

import classes from './HotelNavItem.scss';

const hotelNavItem = (props) => (
    <li className={[classes.Item, props.type === 'vertical' ? classes.ItemVertical : classes.ItemHorizontal].join(' ')}>
        <img src={props.image} alt='Laundry' className={classes.Image}/>
        <p className={`u-fontSize11 u-textColorLight`}>{props.children}</p>
    </li>
);

export default hotelNavItem;


// WEBPACK FOOTER //
// ./src/components/HotelDetail/HotelNav/HotelNavItem/HotelNavItem.js